import { Flex, type FlexProps } from "@chakra-ui/react";
import { useNavigate } from "react-router";

import { Text } from "@equidefi/ui";
import { Icon } from "@equidefi/ui/icon";

type Layout = "ltr" | "rtl";

export type ProfileNavButtonProps = Omit<FlexProps, "children" | "as" | "onClick"> & {
  to: string;
  children: React.ReactNode;
  layout?: Layout;
};

export const ProfileNavButton = ({ to, children, layout = "ltr", ...props }: ProfileNavButtonProps) => {
  const navigate = useNavigate();

  const isLtr = layout === "ltr";

  return (
    <Flex
      as="button"
      type="button"
      onClick={() => navigate(to)}
      align="center"
      justify="space-between"
      gap="3"
      w="full"
      bg="white"
      borderRadius="lg"
      p="4"
      minH="56px"
      boxShadow="0 1px 2px rgba(0, 0, 0, 0.2)"
      border="1px solid"
      borderColor="gray.100"
      textAlign="left"
      cursor="pointer"
      {...props}>
      <Flex align="center" gap="3">
        {!isLtr && <Icon.ChevronLeft size="1.25em" />}

        <Text m="0" fontWeight="700" fontSize="17px" lineHeight="24px">
          {children}
        </Text>
      </Flex>

      {isLtr && <Icon.ChevronRight size="1.25em" />}
    </Flex>
  );
};
